export default __webpack_public_path__ + "static/media/51.8c7a3b10.jpg";